// This created from the `ngx-flag-picker` NPM package (https://www.npmjs.com/package/ngx-flag-picker)
//      Created here, rather than importing, since the package is small and not kept up-to-date.
// Code available here: https://github.com/iamartyom/ngx-flag-picker

// UPDATE
// DE4699: this has deviated from the original implementation/package.
// The component no longer supports flags.

import {
	Component,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
	Renderer2,
	ChangeDetectorRef,
	OnDestroy,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgClass } from '@angular/common';

@Component({
	// Since this component was originally used from an NPM package, its selector was not changed.
	/* eslint-disable-next-line @angular-eslint/component-selector */
	selector: 'ngx-flag-picker',
	templateUrl: './ngx-flag-picker.component.html',
	styleUrls: ['./ngx-flag-picker.component.scss'],
	imports: [MatFormField, MatSelect, NgClass, MatOption],
})
export class NgxFlagPickerComponent implements OnDestroy, OnChanges {
	@Input() selectedCountryCode!: string;
	@Input() countryCodes?: string[];
	@Input() isDisabled?: boolean;

	@Input() customLabels?: Record<string, string>;

	@Output() changedCountryCode = new EventEmitter<string>();

	@ViewChild('selectFlags') selectFlagsElementRef?: ElementRef;

	flipArrow: boolean = false;

	// tslint:disable-next-line: variable-name
	private _isShowListCountryFlags = false;
	set isShowListCountryFlags(value: boolean) {
		this._isShowListCountryFlags = value;
		this.changeDetectorRef.markForCheck();
	}
	get isShowListCountryFlags(): boolean {
		return this._isShowListCountryFlags;
	}

	outsideClickSelectFlags: (() => void) | undefined = () => {};

	constructor(
		private renderer: Renderer2,
		private changeDetectorRef: ChangeDetectorRef
	) {}

	getCountryLabel(countryCode: string): string {
		return this.customLabels && this.customLabels[countryCode]
			? this.customLabels[countryCode]
			: countryCode
				? countryCode.toUpperCase()
				: '';
	}

	public changeSelectedCountryCode(value: string): void {
		this.selectedCountryCode = value;
		this.closeListCountryFlags();
		this.changedCountryCode.emit(this.selectedCountryCode);
	}

	public toggleListCountryFlags(): void {
		if (this.isShowListCountryFlags) {
			this.closeListCountryFlags();
		} else {
			this.openListCountryFlags();
		}
	}

	private openListCountryFlags(): void {
		this.isShowListCountryFlags = true;
		this.subscribeOutsideClickSelectFlags();
	}

	private closeListCountryFlags(): void {
		this.isShowListCountryFlags = false;
		this.unsubscribeOutsideClickSelectFlags();
	}

	private subscribeOutsideClickSelectFlags(): void {
		this.outsideClickSelectFlags = this.renderer.listen(
			'document',
			'click',
			(event) => {
				if (!this.selectFlagsElementRef?.nativeElement.contains(event.target)) {
					this.closeListCountryFlags();
				}
			}
		);
	}

	private unsubscribeOutsideClickSelectFlags(): void {
		if (this.outsideClickSelectFlags) {
			this.outsideClickSelectFlags();
			this.outsideClickSelectFlags = undefined;
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.selectedCountryCode =
			changes?.selectedCountryCode?.currentValue ?? this.selectedCountryCode;
	}

	ngOnDestroy(): void {
		this.unsubscribeOutsideClickSelectFlags();
	}

	toggleFlipArrow(): void {
		this.flipArrow = !this.flipArrow;
	}
}
